module.exports = __webpack_public_path__ + "img/bn.bn91c0cc9.svg";